import { apiCallWrapper } from './apiCallWrapper'
import { EntitiesPaginatedModel } from '../models/EntitiesPaginatedModel'
import { Photo } from '../models/Photo'
import { IdNameModel } from '../models/IdNameModel';

export class PhotosFilter {
    page: number = 1;
    search: string = '';
    toursIds: number[] = [];
}
export default class PhotosApiService {
    public static endPointBase = '/api/photos'
    static update = async (photo: Photo, dispatch: any) => {
        return await apiCallWrapper<Photo>(PhotosApiService.endPointBase, 'POST', dispatch, photo)
    }
    static delete = async (photo: Photo, dispatch: any) => {
        return await apiCallWrapper(`${PhotosApiService.endPointBase}/${photo.id}`, "DELETE", dispatch)

    }
    static getToursWithPhotos = async (dispatch: any) => {
        return await apiCallWrapper<IdNameModel[]>(`${PhotosApiService.endPointBase}/tours`, "GET", dispatch)

    }
    static getPhotos = async (filter: PhotosFilter, dispatch: any) => {
        return await apiCallWrapper<EntitiesPaginatedModel<Photo>>(
            `${PhotosApiService.endPointBase}/list`,
            'POST',
            dispatch,
            filter
        )
    }
}
